export default __webpack_public_path__ + "static/media/default_timeline_image.3fbd6171.png";